let Repeat = localStorage.getItem('path');
let Reg = /(http\:\/\/|https\:\/\/|)(\d+\.){3}\d+\:\d+$/;
let Test = Reg.test(Repeat) ? Repeat : 'http://test.b2b.api.nongwanjia.net';

let Production = 'http://b2b.api.nongwanjia.net';
let hostName = '/api';
// if(location.host === 'h5.nongwanjia.net'){
//     hostName = Production;
// }else{
//     hostName = Test;
// }

let API = {

	bannerList: '/h5/banner',  //首页banner图
    noticeMsgList: '/h5/msg',  // 通知信息
	goodsType:'/h5/platform_cate',
	hotGoodsList:'/h5/flash_sale',  //热卖商品列表
	supplierList:'/h5/partner',
	storeCate:'/h5/store_cate',
	partnerInfo:'/h5/partner_info',
	storeListWithLoc:'/h5/store/listWithLocation',
	twoCategoryGoods:'/h5/goods_cate',   // 获取二级类目商品
	goodsInfo:'/h5/goods_info',   //根据商品id获取商品详细信息
	acticityGoods:'/h5/activity', //按分类获取活动商品
	goodsSearch:'/h5/goods_search',  //根据关键词模糊查询商品
    goodsDetailInfo:'/h5/goods_info',  //根据商品id获取商品详细信息

    cartList: '/h5/cart',       //获取购物车列表
    cartAdd: '/h5/cart/add',   //添加购物车
    cartDel: '/h5/cart/del',    // 删除购物车
    cartUpdate: '/h5/cart/update',    // 更新购物车
    cartCount: '/h5/cart/cnt',  // 查询购物车总数

    cartToSubmit: '/h5/order',   // 下单前表单页面
    submitOrder: '/h5/order/submit',    // 提交订单

    favoriteAdd:'/h5/favorite/add',  //收藏商品或店铺
    favoriteDel:'/h5/favorite/del', //取消收藏
    favoriteGoodsView: '/h5/favorite/goods_chk', // 查看是否收藏



    // 用户登录注册相关
    loginSendSms: '/h5/login/send_login_sms',   // 发送登录验证码
    loginMobile: '/h5/login',   //  手机验证码登录
    loginPwd: '/h5/login/pwd',  //  用户名密码登录
    loginWx: '/h5/login/wx',    //  微信跳转登录
    loginWxInfo: '/h5/login/info',  //  微信token获取用户信息
    loginWxBindMobile: '/h5/login/wx_bind', // 微信绑手机号
    registerPwd: '/h5/login/new',   // 用户名密码注册
    registerSendSms: '/h5/login/send_register_sms',     // 发送注册验证码
    logout: '/h5/logout',    // 退出登录

    myCoupon: '/h5/coupon/my',   // 我的优惠券
    myCouponCount: '/h5/coupon/my_count',   // 我的优惠券总数

    myAddress: '/h5/addr/my',   // 我的收货地址
    myAddressAdd: '/h5/addr/add',   // 新增收货地址
    myAddressMod: '/h5/addr/edit',   // 编辑收货地址
    myAddressDel: '/h5/addr/del',   // 删除收货地址
    myAddressSet: '/h5/my_cur_addr',   // 设置收货地址

    myOrder: '/h5/order/my_list',   // 我的订单
    myOrderCancel: '/h5/order/cancel',  // 取消订单
    myOrderChangeAddr: '/h5/order/addr',    // 修改订单地址
    myOrderDetail: '/h5/order/info',    // 我的订单详情
    myOrderCount: '/h5/order/my_count', // 我的订单数量

    myInfo: '/h5/my',   // 查询我的个人信息
    myInfoMod: '/h5/my/edit_info', // 修改我的个人信息
    myInfoModHead: '/h5/my/avatar', // 修改个人头像

    myFeedback: '/h5/feedback', // 用户反馈列表
    myFeedbackAdd: '/h5/feedback/add',  // 添加反馈内容

    myYakuangCount: '/h5/yk/my_count',  // 押筐 - 获取我的可退个数
    myYakuang: '/h5/yk/my_list',    // 押筐 - 获取我的可退列表

    myIntegralCount: '/h5/integral/my_plateform',   // 我的总积分
    myIntergralStore: '/h5/integral/my_store',      // 我的各店铺积分
    myIntegral: '/h5/integral/my',  // 列表 - 我的积分记录
    myIntegralExchangeList: '/h5/coupon_exchange/list', // 我的积分可兑换优惠劵列表
    myIntegralExchangeCoupon: '/h5/coupon_exchange/exchange',   // 我的积分兑换优惠券

    myFavorite: '/h5/favorite/my',  // 列表 - 我的收藏商品或者店铺

    // 推荐
    myReferrerList: '/h5/my_referrer',  // 列表 - 我的推荐人


    // 字典
    dictYakuang: '/h5/dict/ya_kuang',   // 押筐

    // 获取微信信息
    wxConfig: '/h5/wx_js_sdk_config',


    myStore: '/h5/store/my',
    myStoreRequest: '/h5/store/request',
    myStoreLogoUpload: '/h5/store/upload_logo',
    myStoreBannerUpload: '/h5/store/upload_banner',
    myQuickBuy: '/h5/my_quick_buy',

    // 支付
    wxPaySign: '/wx/pay_config',    // ?out_order_no=134224751&amount=45.55
}

Object.keys(API).forEach(key => {
	API[key] = hostName + API[key];
})

export default API



// WEBPACK FOOTER //
// ./src/assets/js/Api.js